document.addEventListener("DOMContentLoaded", function () {
    const sliderStories = document.querySelectorAll(".gallery-list__swiper");
    const sliderConfig = {
        "slidesPerView": "auto",
        "touchRatio": 1,
        "threshold": 10
    }

    sliderStories.forEach(storySlide => initSlider(storySlide))

    function initSlider(swiperElement) {
        if (!Swiper || !swiperElement) return;
        return new Swiper(swiperElement, sliderConfig)
    }
})